import React, { useState } from 'react';

import {
  bool, func, number, shape, string,
} from 'prop-types';
import { TYPES } from '../../constants';
import DndVerticalSortable from '../../../../../core/components/dnd-vertical-sortable';
import CardItemComponent from '../../../../../core/components/card-item-component';

import {
  Text,
  Image,
  ContainerImageName,
  Modal,
  ModalContent,
  ImageContainer,
  ModalImage,
  Link,
} from './styles';

const CardSortItem = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    cardSortItem: {
      description,
      id,
      itemOrder,
      name,
      imageUrl,
    },
    cardSortItemIndex,
    hideItemName,
    onMove,
    hideTooltip,
  } = props;

  const element = {
    id,
    index: cardSortItemIndex,
    cardSortCategoryId: null,
    description,
    itemOrder,
    name,
    type: TYPES.CARD_SORT_ITEM,
    imageUrl,
  };

  const handleMove = (item, index) => {
    if (item.cardSortCategoryId) return;

    onMove(item.id, index);
  };

  return (
    <>
      <DndVerticalSortable
        onMove={handleMove}
        element={element}
        index={cardSortItemIndex}
        accept={TYPES.CARD_SORT_ITEM}
      >
        <CardItemComponent
          hasTooltip={hideTooltip}
          tooltipContent={description}
        >
          <ContainerImageName>
            {(!hideItemName || !imageUrl) && (
              <Text>{name}</Text>
            )}
            {imageUrl && (
              <Image
                src={imageUrl}
                alt={name}
                onClick={() => setIsModalOpen(true)}
              />
            )}
          </ContainerImageName>
        </CardItemComponent>
      </DndVerticalSortable>
      {isModalOpen && (
        <Modal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          closeIcon
        >
          <ModalContent>
            <ImageContainer>
              <ModalImage
                src={imageUrl}
                alt={name}
              />
            </ImageContainer>
            <Link onClick={() => setIsModalOpen(false)}>
              Exit Image Preview
            </Link>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

CardSortItem.propTypes = {
  cardSortItemIndex: number.isRequired,
  onMove: func.isRequired,
  hideItemName: bool.isRequired,
  hideTooltip: bool.isRequired,
  cardSortItem: shape({
    id: string,
    name: string,
    description: string,
    itemOrder: number,
    imageUrl: string,
  }).isRequired,
};

export default CardSortItem;
